import React from "react";

const Lang = React.createContext({ lang: 1 });

export default Lang;
